export default __webpack_public_path__ + "img/checkmark_success.png";